import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("sales-executive-jobs")!;

export const Route = createFileRoute("/sales-executive-jobs")({
  head: () => pageHead("/sales-executive-jobs"),
  component: () => <CategoryPage category={category} />,
});
